import { combineReducers } from 'redux';

import changePasswordReducer from './changePassword';
import forgotPasswordReducer from './forgotPassword';

export const renewPasswordReducer = combineReducers({
  changePasswordReducer,
  forgotPasswordReducer,
});
